import { useMemo } from 'react';
import { Breakpoint, breakpoints } from '../config/constants';
import { useWindowSize } from './useWindowSize';

export const useWindowBreakpoints = (
    config: {
        mobileBreakpoint: Breakpoint,
        tabletBreakpoint: Breakpoint
    } = { 
        mobileBreakpoint: 'sm', 
        tabletBreakpoint: 'xl'
    }
) => {
    const size = useWindowSize();

    const breakpoint = useMemo(() => {
        return (
            breakpoints.find((bp, i) => {
                return (
                    bp.minWidth >= size.width && (breakpoints[i + 1] ? bp.minWidth < breakpoints[i + 1].minWidth : true)
                );
            }) || breakpoints[0]
        );
    }, [size.width]);

    const _mobileBreakpoint = useMemo(() => {
        return breakpoints.find((bp) => bp.tag === config.mobileBreakpoint)!;
    }, [config.mobileBreakpoint]);

    const _tabletBreakpoint = useMemo(() => {
        return breakpoints.find((bp) => bp.tag === config.tabletBreakpoint)!;
    }, [config.tabletBreakpoint]);

    return {
        breakpoint,
        tags: breakpoints.filter((bp) => bp.minWidth <= size.width).map((bp) => bp.tag),
        isWindowBiggerThan: (breakpoint: Breakpoint) => {
            const _breakpoint = breakpoints.find((bp) => bp.tag === breakpoint)!;
            return size.width >= _breakpoint.minWidth;
        },
        isWindowSmallerThan: (breakpoint: Breakpoint) => {
            const _breakpoint = breakpoints.find((bp) => bp.tag === breakpoint)!;
            return size.width < _breakpoint.minWidth;
        },
        isMobile: size.width < _mobileBreakpoint.minWidth,
        isTablet: size.width >= _mobileBreakpoint.minWidth && size.width < _tabletBreakpoint.minWidth
    };
};
